import { parse } from 'querystring';

import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import { ActionStates, Actions } from '../lib/Actions';
import { container } from '../lib/container';
import { ContainerTypes } from '../lib/core/types/ContainerTypes';
import DatenschutzPage from '../pages/datenschutz.vue';
import FilialfinderPage from '../pages/filialfinder.vue';
import ImpressumPage from '../pages/impressum.vue';
import ContactPage from '../pages/kontakt.vue';
import store from '../store';
import { MutationTypes } from '../store/mutation-types';

const actions = container.get<Actions>(ContainerTypes.Action);
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: '/filialfinder/:path',
		component: FilialfinderPage,
		props: true
	},
	{
		path: '/contact',
		component: ContactPage
	},
	{
		path: '/copyright',
		component: DatenschutzPage
	},
	{
		path: '/impressum',
		component: ImpressumPage
	},
	{
		path: '*',
		redirect: '/filialfinder/home'
	}
];

const router = new VueRouter({
	routes
});

router.afterEach((to, from) => {
	console.debug(`Navigated from '${from.path}' to '${to.path}'`);

	const isOnHome = to.path.includes('home');
	if (isOnHome) {
		actions.goIfStateChanged(ActionStates.HomePage);
	}

	store.commit(MutationTypes.routeTo, to.path);

	const params = parse(location.search ? location.search.slice(1) : '');
	store.commit(MutationTypes.setAppView, params.isApp === 'true');
});

export default router;
